var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("el-switch", {
        attrs: { "active-color": "#13ce66", "inactive-color": "#808080" },
        on: { change: _vm.updateRPA },
        model: {
          value: _vm.openRPA,
          callback: function ($$v) {
            _vm.openRPA = $$v
          },
          expression: "openRPA",
        },
      }),
      _vm._v(" 啟用RPA自動收錄履歷 "),
      _vm.openRPA
        ? [
            _c("div", { staticClass: "page-tabs mt-4" }, [
              _c(
                "a",
                {
                  class: { active: _vm.currentTab === 0 },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      ;(_vm.currentTab = 0), (_vm.confirmPassword = null)
                    },
                  },
                },
                [_vm._v(" GMAIL ")]
              ),
              _c(
                "a",
                {
                  class: { active: _vm.currentTab === 1 },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      ;(_vm.currentTab = 1), (_vm.confirmPassword = null)
                    },
                  },
                },
                [_vm._v(" O365 ")]
              ),
            ]),
            _c(
              "div",
              { staticClass: "card search-card" },
              [
                _c("ValidationObserver", {
                  ref: "setting",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ handleSubmit, reset }) {
                          return [
                            _c(
                              "form",
                              {
                                on: {
                                  reset: function ($event) {
                                    $event.preventDefault()
                                    return reset.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "card-body" }, [
                                  _c("div", { staticClass: "form-row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 col-sm-12" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("信箱")]
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.trim",
                                                  value: _vm.setting.account,
                                                  expression: "setting.account",
                                                  modifiers: { trim: true },
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                placeholder: "請輸入Email",
                                              },
                                              domProps: {
                                                value: _vm.setting.account,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.setting,
                                                    "account",
                                                    $event.target.value.trim()
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.$forceUpdate()
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-3 col-sm-12" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "ValidationProvider",
                                              {
                                                attrs: {
                                                  name: "信箱密碼",
                                                  vid: "password",
                                                },
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [_vm._v("信箱密碼")]
                                                ),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value:
                                                        _vm.setting.password,
                                                      expression:
                                                        "setting.password",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "password",
                                                    placeholder: "請輸入密碼",
                                                  },
                                                  domProps: {
                                                    value: _vm.setting.password,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.setting,
                                                        "password",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-3 col-sm-12" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c("ValidationProvider", {
                                              attrs: {
                                                name: "確認密碼",
                                                rules: {
                                                  required: _vm.setting.password
                                                    ? true
                                                    : false,
                                                  confirmed: "password",
                                                },
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({ errors }) {
                                                      return [
                                                        _c(
                                                          "label",
                                                          {
                                                            attrs: { for: "" },
                                                          },
                                                          [_vm._v("確認密碼")]
                                                        ),
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model.trim",
                                                              value:
                                                                _vm.confirmPassword,
                                                              expression:
                                                                "confirmPassword",
                                                              modifiers: {
                                                                trim: true,
                                                              },
                                                            },
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            type: "password",
                                                            placeholder:
                                                              "請再次輸入密碼",
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm.confirmPassword,
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              )
                                                                return
                                                              _vm.confirmPassword =
                                                                $event.target.value.trim()
                                                            },
                                                            blur: function (
                                                              $event
                                                            ) {
                                                              return _vm.$forceUpdate()
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-danger",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(errors[0])
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-2 col-sm-12" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn btn-primary",
                                                staticStyle: {
                                                  "margin-top": "30px",
                                                  "margin-left": "10px",
                                                },
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return handleSubmit(
                                                      _vm.updateSetting
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" 儲存 ")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm.currentTab === 1
                                    ? _c("div", { staticClass: "form-row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 col-sm-12" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [_vm._v("應用程式識別碼")]
                                                ),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value:
                                                        _vm.setting
                                                          .O365ClientId,
                                                      expression:
                                                        "setting.O365ClientId",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    placeholder:
                                                      "請輸入應用程式識別碼",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.setting.O365ClientId,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.setting,
                                                        "O365ClientId",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "col-md-4 col-sm-12" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [_vm._v("目錄識別碼")]
                                                ),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value:
                                                        _vm.setting
                                                          .O365TenantId,
                                                      expression:
                                                        "setting.O365TenantId",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "text",
                                                    placeholder:
                                                      "請輸入目錄識別碼",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.setting.O365TenantId,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.setting,
                                                        "O365TenantId",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3156790224
                  ),
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }